import { render, staticRenderFns } from "./RegisterDashboard.vue?vue&type=template&id=2ebd3184&scoped=true"
import script from "./RegisterDashboard.vue?vue&type=script&lang=js"
export * from "./RegisterDashboard.vue?vue&type=script&lang=js"
import style0 from "./RegisterDashboard.vue?vue&type=style&index=0&id=2ebd3184&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebd3184",
  null
  
)

export default component.exports